enum GlobalActionsEnum {
    ToastAdd = 'GLOBAL/TOAST/ADD',
    ToastHide = 'GLOBAL/TOAST/HIDE',
}

export default GlobalActionsEnum;
